<template lang='pug'>
  v-dialog(v-model='open' max-width='700px')
    v-card
      v-card-title
        span.h4.font-weight-light Enter Credit Card
      v-card-text
        form(@submit.prevent='updatePaymentSource').mb-4.mt-4
          #card-element
          #card-errors.red--text
      v-card-actions
        a(target='_blank', href='http://www.stripe.com').ml-4
          img(v-if='!$vuetify.theme.dark' src='../assets/powered_by_stripe.png' height='40')
          img(v-if='$vuetify.theme.dark' src='../assets/powered_by_stripe_white.png' height='40')
        v-spacer
        v-btn(text type='submit' color='primary' @click.stop.prevent='updatePaymentSource' :loading='loading') Save Card
</template>

<script>
import StripeAPI from '../api/stripe';
import Notifications from '../services/notification.service';

export default {
  name: 'CreditCard',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    open: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    stripeClass() {
      if (this.$vuetify.theme.dark) return 'darkMode';
      return 'lightMode';
    }
  },
  methods: {
    async loadStripeElement() {
      let stripePk;
      try {
        stripePk = await StripeAPI.getPublishKey(); //TODO Vuex this?
      } catch (error) {
        console.error(error);
        return;
      }
      // eslint-disable-next-line no-undef
      this.stripe = Stripe(stripePk);
      this.elements = this.stripe.elements();
      const style = this.$vuetify.theme.dark ? this.elementsStyleDark : this.elementsStyle;
      this.card = this.elements.create('card', {style});
      this.card.mount('#card-element');
    },
    async updatePaymentSource() {
      if (!this.stripe) return Notifications.alert('There was a problem communicating with Stripe. Please contact support or try again later.');
      try {
        this.loading = true;
        const result = await this.stripe.createToken(this.card);
        if (result.error) {
          // Inform the user if there was an error.
          const errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
          return null;
        }
        this.$emit('token', result);
        this.open = false;
      } catch (error) {
        console.error(error);
        await Notifications.alert('An error occurred saving payment information. Check console logs for details. Please contact support');
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      async handler(val) {
        if (!val) return;
        await this.loadStripeElement();
      }
    }
  },
  data() {
    return {
      loading: false,
      stripe: null,
      card: null,
      elements: null,
      elementsStyle: {
        base: {
          color: '#32325d',
          lineHeight: '18px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      },
      elementsStyleDark: {
        base: {
          color: '#FFFFFF',
          lineHeight: '18px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#CCCCCC'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }
    };
  }
};
</script>

<style lang='scss' scoped>
.StripeElement {
  background-color: transparent;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid #AAAAAA;
}

.StripeElement--invalid {
  border-color: #fa755a;
}
/*
.lightMode {
  .StripeElement {
    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }
}

.darkMode {
  .StripeElement {
    color: white !important;
    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }
}*/

</style>
